import { combineReducers } from 'redux'

import {
  createReducer,
  updateObject,
  updateItemInArray,
  createNamedReducer,
} from 'helpers/ReducerUtil'
import {
  TOGGLE_POPUP,
  TOGGLE_FILTER,
  INITIALIZE_FILTER,
  PART_TYPE,
  UPDATE_CONFIG_SELECTION,
  UPDATE_CONFIG_SOURCE,
  ADD_CONFIG,
  DELETE_PART,
  UPDATE_CURRENT_CONFIG,
  REFRESH_FILTER,
  PHASE_COUNT,
  UPDATE_PHASE_COUNT,
  SELECT_FILTER,
  DELETE_FILTER,
  UPDATE_EDP_PEAK,
  UPDATE_EDP_CONTINUOUS,
  UPDATE_OUTPUT_VOLTAGE,
  EDP_PEAK,
  EDP_CONTINUOUS,
  OUTPUT_VOLTAGE, 
  RENDER_EXTRA_INPUT,
  RESET_FILTER,
  VENDOR_NAME,
  EFFICIENCY,
  UPDATE_EFFICIENCY,
  PART_NUMBER,
  IS_EDIT_PART,
  IS_ADD_PART,
  EDIT_CONFIG
} from './constants'

const togglePopup = (value) => !value

const isEditPart = (value, action) => action.value
const isAddPart = (value, action) => action.value

const toggleFilter = (values, action) => {
  const { index } = action
  return updateObject(values, {[index]: !(values[index])})
}

const refreshFilter = (values, action) => {
  let refreshedFilters = { ...values }

  for (let filterName in refreshedFilters) {
    if (refreshedFilters.hasOwnProperty(filterName)) {
      refreshedFilters[filterName] = false
    }
  }

  return refreshedFilters
}

const selectFilter = (values, action) => {
  const { filterType } = action
  return [...values, filterType]
}

const deleteFilter = (values, action) => {
  const { index } = action
  const deletedFilters = [...values]
  deletedFilters.splice(index, 1)

  return deletedFilters
}

const resetFilter = (values, action) => {
  return action.defaultFilter
}

const updateConfigSelection = (values, action) => {
  return action.newConfig
}

const updateConfigSource = (values, action) => {
  return action.newConfig
}

const editConfig = (values, action) => {
  const {id, configs} = action
  const newValue = [...values]
 
  values.some((value, index) => {
    if (id == 0){
      if (!value.id && configs[0].railType === value.railType) {
        newValue[index] = updateObject(value, action.configs[0])
        return true
      }
    }
    else if (value.id === id) {
        newValue[index] = updateObject(value, action.configs[0])
        return true
      }
    })
    return newValue
}

const addConfig = (value, action) => {
  const newParts = [...value, ...(action.configs)]
  const updatedNvvdd = []
  const updatedFbvdd = []
  newParts.forEach((part)=>{
    if (part.railType == 'NVVDD') updatedNvvdd.push(part)
    else updatedFbvdd.push(part)
  })
  const result = updatedNvvdd.concat(updatedFbvdd)
  return result
}


const deletePart = (value, action) => {
  const { deleteId, railType, hasId } = action
  const newParts = [...value]
  let count = 0
  if (hasId) {
    value.forEach((value, index) => {
      if (value.railType === railType) {
        if (value.id === deleteId) {
          newParts.splice(index, 1)
        }
      }
    })
  } else {
    value.forEach((value)=>{
      if (value.railType == 'NVVDD') count = count + 1
    })
    if (railType=='FBVDD') newParts.splice((deleteId+count),1)
    else newParts.splice((deleteId),1)
  }
  
  const updatedNvvdd = []
  const updatedFbvdd = []
  newParts.forEach((part)=>{
    if (part.railType == 'NVVDD') updatedNvvdd.push(part)
    else updatedFbvdd.push(part)
  })
  const result = updatedNvvdd.concat(updatedFbvdd)
  return result
}

const updatePhaseCount = (values, action) => {
  const { id, railType, value: phaseCount, hasId } = action
  let newValue = [...values]
  // let count = 0

  if (hasId) {
    values.some((value, index) => {
      if (value.railType === railType) {
        if (value.id === id) {
          newValue[index] = updateObject(value, { phaseCount: parseInt(phaseCount) })
          return true
        }
      }
    })
  } else {
    // console.log(values, action)
    // values.forEach((value, index) => {
    //   if (value.railType === railType) {
    //     newValue[index] = updateObject(value, { phaseCount: parseInt(phaseCount)})
    //   }
    // })

    let currentRailType = []
    values.forEach((value, index) => {
      if (value.railType === railType) {
        currentRailType.push(value)
        if (currentRailType[id]) {
          newValue[index] = updateObject(value, { phaseCount: parseInt(phaseCount)})
        }
      }
    })
  }
  return newValue
}

const updateEfficiency = (values, action) => {
  const { id, railType, value: efficiency, hasId } = action
  let newValue = [...values]
  if (hasId) {
    values.some((value, index) => {
      if (value.railType === railType) {
        if (value.id === id) {
          newValue[index].efficiency = parseFloat(efficiency)
          return true
        }
      }
    })
  }
  else {
    // values.forEach((value)=>{
    //   if (value.railType == 'NVVDD') count = count + 1
    // })
    // if (railType=='FBVDD') newValue[id+count].efficiency = parseFloat(efficiency)
    // else newValue[id].efficiency = parseFloat(efficiency)
    let currentRailType = []
    values.forEach((value, index) => {
      if (value.railType === railType) {
        currentRailType.push(value)
        if (currentRailType[id]) {
          newValue[index].efficiency = parseFloat(efficiency)
        }
      }
    })
  }
  return newValue
}

const updateEdpPeak = (values, action) => {
  return values.map(value => {
    if (value.railType === RENDER_EXTRA_INPUT) {
      value.edpPeak = parseInt(action.value)
    }

    return value
  })
}

const updateEdpContinuous = (values, action) => {
  return values.map(value => {
    if (value.railType === RENDER_EXTRA_INPUT) {
      value.edpContinuous = parseInt(action.value)
    }

    return value
  })
}

const updateOutputVoltage = (values, action) => {
  return values.map(value => {
    if (value.railType === RENDER_EXTRA_INPUT) {
      value.outputVoltage = parseInt(action.value)
    }

    return value
  })
}

const updateCurConfig = (value, action) => {
  return action.curConfig
}

const isEditPartReducer = createReducer('', {
  [IS_EDIT_PART]: isEditPart
})

const isAddPartReducer = createReducer('',{
  [IS_ADD_PART]: isAddPart
})

const togglePopupReducer = createReducer(false, {
  [TOGGLE_POPUP]: togglePopup
})

const selectFilterReducer = createReducer([], {
  [SELECT_FILTER]: selectFilter,
  [DELETE_FILTER]: deleteFilter,
  [RESET_FILTER]: resetFilter,
})

const updateConfigSelectionReducer = createReducer([], {
  [UPDATE_CONFIG_SELECTION]: updateConfigSelection
})

const updateConfigSourceReducer = createReducer([], {
  [UPDATE_CONFIG_SOURCE]: updateConfigSource
})

const updateCurConfigReducer = createReducer({}, {
  [UPDATE_CURRENT_CONFIG]: updateCurConfig
})

const initFilters = (state, action) => {
  const { filters } = action
  let newFilters = {...filters}
  for (const filterKey in filters) {
    if (!filters.hasOwnProperty(filterKey)) continue

    newFilters[filterKey] = false
  }

  return newFilters
}

const filterReducer = createReducer({}, {
  [INITIALIZE_FILTER]: initFilters,
  [TOGGLE_FILTER]: toggleFilter,
  [REFRESH_FILTER]: refreshFilter,
})



export const voltageValueReducer = createReducer([], {
  [UPDATE_PHASE_COUNT]: updatePhaseCount,
  [UPDATE_EFFICIENCY]: updateEfficiency,
  [UPDATE_EDP_PEAK]: updateEdpPeak,
  [UPDATE_EDP_CONTINUOUS]: updateEdpContinuous,
  [UPDATE_OUTPUT_VOLTAGE]: updateOutputVoltage,
  [ADD_CONFIG]: addConfig,
  [DELETE_PART]: deletePart,
  [EDIT_CONFIG]: editConfig
})

export const createUiReducer = (uiPath) => {
  const namedUiReducer = (type) => {
    return createNamedReducer(type + uiPath, filterReducer)
  }

  return combineReducers({
    togglePopup: togglePopupReducer,
    configSelection: updateConfigSelectionReducer,
    configSource: updateConfigSourceReducer,
    curConfig: updateCurConfigReducer,
    vendorNameFilter: namedUiReducer(VENDOR_NAME),
    efficiencyFilter: namedUiReducer(EFFICIENCY),
    partNumberFilter: namedUiReducer(PART_NUMBER),
    partTypeFilter: namedUiReducer(PART_TYPE),
    phaseCountFilter: namedUiReducer(PHASE_COUNT),
    selectedFilter: selectFilterReducer,
    isEditPart: isEditPartReducer,
    isAddPart: isAddPartReducer
  })
}

